var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 104.211,
    viewBox: "0 0 22 26.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.474h6.368V0h9.264v14.474H22L11 26.053 0 14.473z",
    fill: "#b3b3b3",
    fillRule: "evenodd",
    "data-name": "\\u5408\\u4F53 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomOff);
export default __webpack_public_path__ + "static/media/arrowBottomOff.97274014f43c361f.svg";
export { ForwardRef as ReactComponent };